import { createTracker, EventTypes } from 'redux-segment';
import { LOCATION_CHANGE } from 'connected-react-router';
import { getCurrentLanguage } from 'modules/language/selectors/language';
import mediaType from 'modules/appointmentInfo/components/MediaGallery/mediaType';

import { SEND_OTP_CODE } from 'modules/auth/actions/sendOtpCode';
import { LOGOUT } from 'modules/auth/actions/logout';
import { DOWNLOAD_MOBILE_APP } from 'modules/auth/actions/downloadMobileApp';
import { ADD_MODAL } from 'modules/messageSystem/actions/addModal';
import { MODAL_TERMS_AND_CONDITIONS } from 'modules/messageSystem/constants/modalCodes';
import { TOS_DECLINE_ACCEPTED } from 'modules/auth/actions/termsOfService';
import { SET_TERMS_AND_CONDITIONS_ACCEPTED } from 'modules/auth/actions/acceptTermsAndConditions';
import { EDIT_FILE_META_DATA_PARAMETERS } from 'modules/appointmentInfo/actions/editFileMetaDataParameters';
import { LANGUAGE_CHANGE } from 'modules/language/actions/selectLanguage';
import { SHOW_PROFILE_BOX } from 'modules/user/actions/showProfileBox';

const getReferrer = state => {
  if (!state.router.location) return '';
  return `${ window.location.origin }${ state.router.location.pathname }${ state.router.location.search }`;
};

// see "Page (web)" section
// https://connectedhs.atlassian.net/wiki/spaces/FPD/pages/117236/Analytics+BI
const getPageName = pathname => {
  switch (true) {
    case (pathname.includes('organization-selection')):
      return 'organization selection';
    case (pathname.includes('login')):
      return 'login ID';
    case (pathname.includes('otp-verification')):
      return 'otp';
    case (pathname.includes('appointments')):
      return 'Homescreen';
    default:
      return '';
  }
};

const trackerMapper = {
  mapper: {
    [LOCATION_CHANGE]: (getState, action) => ({
      eventType: EventTypes.page,
      eventPayload: {
        name: getPageName(action.payload.location.pathname),
        properties: {
          referrer: getReferrer(getState()),
        },
      },
    }),
    [SEND_OTP_CODE.success]: () => ({
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Patient login',
      },
    }),
    [LOGOUT.success]: () => ({
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Sign Out',
        properties: {
          succeeded: true,
        },
      },
    }),
    [DOWNLOAD_MOBILE_APP]: () => ({
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Button Clicked',
      },
    }),
    [TOS_DECLINE_ACCEPTED]: () => ({
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Terms and Conditions Reviewed',
        properties: {
          action: 'declined',
        },
      },
    }),
    [SET_TERMS_AND_CONDITIONS_ACCEPTED.success]: () => ({
      eventType: EventTypes.track,
      eventPayload: {
        event: 'Terms and Conditions Reviewed',
        properties: {
          action: 'approved',
        },
      },
    }),
    [ADD_MODAL]: (_, action) => {
      if (action.meta.typeId === MODAL_TERMS_AND_CONDITIONS) {
        return {
          eventType: EventTypes.track,
          eventPayload: {
            event: 'Terms and Conditions Viewed',
          },
        };
      }
    },
    [EDIT_FILE_META_DATA_PARAMETERS.success]: (_, action) => {
      const type = action.meta.mimeType === mediaType.PDF ? 'pdf' : 'image';
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Media Name Updated',
          properties: {
            type,
            context: 'from gallery',
          },
        },
      };
    },
    [LANGUAGE_CHANGE]: (_, action) => {
      const { language, location } = action.payload;
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Language Updated',
          properties: {
            language,
            location,
          },
        },
      };
    },
    [SHOW_PROFILE_BOX]: getState => {
      const { avatar } = getState().auth.userInfo.profile;
      return {
        eventType: EventTypes.track,
        eventPayload: {
          event: 'Profile box viewed',
          properties: {
            'Selected language': getCurrentLanguage(),
            'User image uploaded': !!avatar,
          },
        },
      };
    },
  },
};


export default createTracker(trackerMapper);
